<template>
  <LISAFormPanel v-if="isLISA3" v-bind="$attrs" :title="title" :content-class="contentClass">
    <slot />
    <template v-if="'footer' in $slots" #footer>
      <slot name="footer" />
    </template>
  </LISAFormPanel>
  <div v-else class="lisa3-form-panel__legacy">
    <h3 v-if="title">{{ title }}</h3>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { LISAFormPanel } from "@fi-solutions/lisa-ui";
import { isLISA3 } from "@/composables/useLISA3";

defineProps<{
  title?: string;
  contentClass?: string;
}>();
</script>

<style scoped lang="scss">
.lisa3-form-panel__legacy {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  h2 {
    margin: 0;
    padding-bottom: 0;
  }
}
</style>
